import classNames from "classnames";
import { FC, useRef, useState } from "react";
import { useOnClickOutside } from "../../hooks/onClickOutside";
import styles from "./styles.module.css";

type IconWithTooltip = {
  text: string;
  icon: React.ReactElement;

  minWidth?: number;
};

const IconWithTooltip: FC<IconWithTooltip> = (props) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useRef(null);
  useOnClickOutside(ref, () => setShowTooltip(false));

  return (
    <div ref={ref} className={classNames("relative")}>
      {showTooltip && (
        <div
          className={classNames(styles.tooltip)}
          style={{ minWidth: props.minWidth || 0 }}
        >
          {props.text}
        </div>
      )}

      <div
        className={classNames("hover:cursor-pointer")}
        onClick={(e: any) => {
          e.preventDefault();
          
          setShowTooltip(!showTooltip)
        }}
      >
        {props.icon}
      </div>
    </div>
  );
};

export default IconWithTooltip;
